<template>
  <div
    v-loading="isLoading"
    class="vg_wrapper"
    element-loading-text="正在加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-card>
      <div class="vg_mb_8">
        统计时间：
        <el-date-picker
          v-model="dateRange"
          class="vg_ml_8 vg_mr_8 topDateRangeSearch"
          end-placeholder="结束日期"
          range-separator="至"
          size="small"
          value-format="timestamp"
          start-placeholder="开始日期"
          type="daterange"
        />
        <el-button class="buttonText" round size="mini" @click="timeScope(1)">近一月</el-button>
        <el-button class="buttonText" round size="mini" @click="timeScope(3)">近三月</el-button>
        <el-button class="buttonText" round size="mini" @click="timeScope(6)">近六月</el-button>
        <el-button class="buttonText" round size="mini" @click="timeScope(0)">全部</el-button>
        <el-button size="mini" type="primary" @click="getTableData()">查询</el-button>
        <el-button size="mini" type="info" @click="refresh">刷新</el-button>
      </div>
      <search-table
        ref="searchTable"
        :data="tableData"
        :tableRowKey="'id'"
        :columns="tableProperties"
        :need-pagination="true"
        :total-page="totalPage"
        :columnMove="false"
        @getTableData="getTableData"
        :page-size="10"
      >
      </search-table>
    </el-card>
  </div>
</template>

<script>
import SearchTable from '@/components/SearchTableV3.vue';
import { cloneDeep } from 'lodash';
import { get } from '@api/request';
import { dataStaticsAPI } from '@api/modules/stat';
import { setTime } from '@api/public';
import { getDateNoTime } from '@assets/js/dateUtils';
import helper from '@assets/js/helper';

export default {
  components: { SearchTable },
  name: 'FabricStatistics',
  data() {
    return {
      tableProperties: [
        { label: '序号', prop: 'index', type: 'index', labelWidth: '50px' },
        { label: '物料编号', prop: 'mtrl_no', itemType: 'input', input: false, sortable: false, widthAuto: true },
        {
          label: '物料图片',
          prop: 'imge_url',
          itemType: 'input',
          input: false,
          sortable: false,
          widthAuto: true,
          subItem: {
            type: 'image',
            thumbnail: row => helper.picUrl(row.imge_url),
            image: row => helper.picUrl(row.imge_url)
          }
        },
        { label: '物料名称', prop: 'mtrl_name', itemType: 'input', input: true, sortable: false, widthAuto: true },
        { label: '潘通色号', prop: 'mtrl_color', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { label: '物料门幅', prop: 'mtrl_width', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { label: '物料毛高', prop: 'mtrl_thick', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { label: '入库米数', prop: 'total_meters', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { label: '使用频次', prop: 'numberOfUses', itemType: 'input', input: false, sortable: false, widthAuto: true },
        {
          label: '最近出库时间',
          prop: 'delivery_time',
          itemType: 'input',
          input: false,
          sortable: false,
          widthAuto: true,
          formatter: val => getDateNoTime(val, true)
        }
      ],
      tableData: [],
      dateRange: [],
      isLoading: false,
      totalPage: 0
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.getTableData();
    },
    getSearchForm() {
      let searchForm = cloneDeep(this.$refs.searchTable.searchForm);
      setTime(searchForm, 'start_time', 'end_time', this.dateRange || [], true);
      return searchForm;
    },
    getTableData() {
      this.isLoading = true;
      get(dataStaticsAPI.getFabricStatistics, this.getSearchForm()).then(({ data }) => {
        if (data.code === 0) {
          this.tableData = data.data.list;
          this.totalPage = data.data.total;
          this.isLoading = false;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    refresh() {
      this.dateRange = [];
      this.$refs.searchTable.resetFields();
      this.initData();
    },
    timeScope(val) {
      this.dateRange = val === 0 ? [] : [Math.floor(new Date().setMonth(new Date().getMonth() - val)), Math.floor(Date.now())];
      this.getTableData();
    }
  }
};
</script>

<style scoped>
::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 300px;
}
</style>
